<template>
  <sidebar
  :addTitle="$t('KPU.KeyProject.AddNew')"
  :editTitle="$t('KPU.KeyProject.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('KPU.KeyProject.ProjectName')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('KPU.KeyProjectType.Name')"
              v-model="keyProjectProjectName"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('KPU.KeyProject.KeyProjectType')}}</form-label>
            <ValidationProvider :name="$t('KPU.KeyProject.KeyProjectType')" rules="required" v-slot="{ errors }">
              <v-select
                label="name"
                :options="keyProjectTypes"
                v-model="keyProjectKeyProjectTypeId"
                :reduce="type => type.id"
                class="w-full"
              />
              <validation-message
                >{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('KPU.KeyProject.District')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('KPU.KeyProject.District')"
              v-model="keyProjectDistrict"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('KPU.KeyProject.Country')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('KPU.KeyProject.Country')"
              v-model="keyProjectCountry"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('KPU.KeyProject.Property')" v-slot="{ errors }">
              <validated-input
              :label="$t('KPU.KeyProject.Property')"
              v-model="keyProjectProperty"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('KPU.KeyProject.DocumentLibraryUrl')" v-slot="{ errors }">
              <validated-input
              :label="$t('KPU.KeyProject.DocumentLibraryUrl')"
              v-model="keyProjectDocumentLibraryUrl"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <vs-checkbox v-model="keyProjectIsActive" class="mb-2 mt-10">{{$t('KPU.KeyProject.IsActive')}}</vs-checkbox>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>

import {
  ValidatedInput,
  ValidationMessage,
  FormLabel,
  Sidebar
} from "../../../../shared/components";
import vSelect from 'vue-select'


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    FormLabel,
    vSelect
  },
  data() {
    return {
      keyProjectId: 0,
      keyProjectProjectName: "",
      keyProjectDistrict : "",
      keyProjectCountry : "",
      keyProjectProperty : "",
      keyProjectIsActive: true,
      keyProjectKeyProjectTypeId : null,
      keyProjectDocumentLibraryUrl : "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    },
    keyProjectTypes() {
      return this.$store.state.kpu.keyProjectTypes;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, projectName, district, country, property, isActive, keyProjectTypeId, documentLibraryUrl } = JSON.parse(JSON.stringify(this.data));
      this.keyProjectId = id;
      this.keyProjectProjectName = projectName;
      this.keyProjectDistrict = district;
      this.keyProjectProperty = property;
      this.keyProjectCountry = country;
      this.keyProjectIsActive = isActive;
      this.keyProjectKeyProjectTypeId = keyProjectTypeId;
      this.keyProjectDocumentLibraryUrl = documentLibraryUrl;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;

      this.keyProjectId = 0;
      this.keyProjectProjectName = "";
      this.keyProjectDistrict = "";
      this.keyProjectCountry = "";
      this.keyProjectProperty = "";
      this.keyProjectIsActive = true;
      this.keyProjectKeyProjectTypeId = null;
      this.keyProjectDocumentLibraryUrl = "";
    },

    async submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.keyProjectId,
            projectName: this.keyProjectProjectName,
            district : this.keyProjectDistrict,
            property : this.keyProjectProperty,
            country : this.keyProjectCountry,
            isActive : this.keyProjectIsActive,
            keyProjectTypeId :  this.keyProjectKeyProjectTypeId,
            documentLibraryUrl : this.keyProjectDocumentLibraryUrl
          };

          this.$vs.loading();
         
          if (this.keyProjectId !== null && this.keyProjectId > 0) {
            this.$store.dispatch("kpu/updateKeyProject", obj).then((result) => {
              this.$emit("onKeyProjectUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("kpu/addKeyProject", obj).then((result) => {
              this.$emit("onKeyProjectInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
